/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ van: NonNullable<unknown>, tot: NonNullable<unknown>, duur: NonNullable<unknown> }} Planning_Rooster_Sleep_LabelInputs */

const nl_planning_rooster_sleep_label = /** @type {(inputs: Planning_Rooster_Sleep_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.van} – ${i?.tot} · ${i?.duur} min`)
};

/**

* @param {Planning_Rooster_Sleep_LabelInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_sleep_label = /** @type {((inputs: Planning_Rooster_Sleep_LabelInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Sleep_LabelInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_sleep_label(inputs)
});
export { planning_rooster_sleep_label as "planning.rooster.sleep_label" }